// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2G8i6","select":"Header_select__1wa2z","clinic":"Header_clinic__2M0Ub"};